import type { TOC } from '@ember/component/template-only'
import bannerFeatureBadge from '@images/banner_feature_badge.png'
import { t } from 'ember-intl'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Signature {
  Args: {
    title: string
    subtitle: string
    link: string
    linkText: string
    image: string
    features: string[]
  }
}

export const Banner: TOC<Signature> = <template>
  <div class="safari-gap-6 mx-auto flex max-w-(--breakpoint-lg)">
    <div
      class="rounded-2xl border-4 border-white bg-[linear-gradient(97deg,#F5FBFD_2.78%,#F8F0FF_97.22%)] p-4 shadow-xl sm:p-6 md:p-8"
    >
      <div class="grid items-center gap-6 lg:grid-cols-5 lg:gap-8">
        <div class="flex flex-1 flex-col items-start gap-4 self-stretch lg:col-span-3 lg:gap-6">
          <h2
            class="bg-linear-to-r from-[#A32A70] to-[#652D90] bg-clip-text text-xl leading-7 font-semibold tracking-normal text-transparent lg:text-2xl lg:leading-8"
          >{{@title}}</h2>
          <p class="text-base leading-relaxed text-[#0E1E37] lg:text-lg">{{@subtitle}}</p>
          <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4">
            {{#each @features as |feature|}}
              <div class="flex items-center gap-3">
                <img src={{bannerFeatureBadge}} alt={{t "components.banner.featureBadge"}} class="h-5 w-10" />
                <span
                  class="text-base leading-6 font-normal tracking-normal text-neutral-300"
                  data-test-feature-text={{feature}}
                >{{feature}}</span>
              </div>
            {{/each}}

          </div>
          <a
            href={{@link}}
            target="_blank"
            rel="noopener noreferrer"
            class="flex max-h-9 w-full items-center justify-center gap-3 rounded-lg bg-pink-300 px-4 py-2 text-center text-sm leading-6 font-medium tracking-normal text-white transition-colors duration-200 hover:bg-pink-400 hover:text-white focus:bg-pink-300 focus:text-white sm:w-auto sm:px-6 sm:text-base"
          >
            {{@linkText}}
            <PhosphorIcon @icon="phosphor-arrow-square-out-bold" />
          </a>
        </div>
        <div class="flex items-center justify-center overflow-visible lg:col-span-2">
          <img src={{@image}} alt={{@title}} class="h-auto lg:absolute" />
        </div>
      </div>
    </div>
  </div>
</template>
